import { render, staticRenderFns } from "./SmsListAddNew.vue?vue&type=template&id=39b8e52e"
import script from "./SmsListAddNew.vue?vue&type=script&lang=js"
export * from "./SmsListAddNew.vue?vue&type=script&lang=js"
import style0 from "./SmsListAddNew.vue?vue&type=style&index=0&id=39b8e52e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports